import React from "react";
import { CarbonRemovalProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import RemovalIcon from "@ecologi/assets/icons/ProjectInsights/removal.svg";

const PATH = "/images/app/forest/carbon_removal/pictograms/";

export const carbonRemovalVisuals: Record<
  CarbonRemovalProjectType,
  ProjectVisualsType
> = {
  [CarbonRemovalProjectType.AfforestationReforestationAndRevegetation]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}arr.svg`,
  },
  [CarbonRemovalProjectType.BlueCarbon]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}blue-carbon.svg`,
  },
  [CarbonRemovalProjectType.Biochar]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}biochar.svg`,
  },
  [CarbonRemovalProjectType.DirectAirCapture]: {
    icon: <></>,
    pictogram: "",
  },
  [CarbonRemovalProjectType.EnhancedRockWeathering]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}erw.svg`,
  },
  [CarbonRemovalProjectType.RegenerativeAgriculture]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}regenerative-agriculture.svg`,
  },
  [CarbonRemovalProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [CarbonRemovalProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
